import colors from '@/design/colors';
import shadows from '@/design/shadows';
import styled from 'styled-components';

export const ModalContent = styled.div`
  background-color: ${colors.white};
  box-shadow: ${shadows.shadowModal};
  border-radius: 16px;
`;
